import { gauntletBank } from '../../../data/GauntletBank';

export const BATTLE_GAMES = {
  'final-exam-1': {
    id: "game_final_exam",
    title: "The Application Gauntlet",
    
    // 1. THE BRIEFING
    preGameBriefing: {
        title: "The Gauntlet",
        script: "This is it. The final screening. You are competing against 100 other applicants for 1 spot. The hiring manager is ruthless. Speed matters, but accuracy matters more. One wrong move, one tone-deaf email, one missed deadline, and you are cut. Prove you belong here.",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
    },

    // 2. FAILURE LOGIC
    failureLogic: {
        'eliminated': {
            title: "Application Rejected",
            script: "You were cut. The competition was fierce, and you made a fatal error. In this market, 'good enough' gets you rejected. You need to be flawless. Review the feedback and try again.",
            videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
        },
        'timeout': {
            title: "Too Slow",
            script: "While you were thinking, someone else took the job. Decisiveness is a leadership trait. Hesitation is a red flag.",
            videoUrl: null
        }
    },

    // 3. EXPANDED QUESTION POOL (For Shuffling)
    questions: gauntletBank
  }
};